class ChangeColor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    jQuery(function() {
      const Select = jQuery('.selected');
        jQuery(Select).on('change', function(){
          if (jQuery(Select).val() !== ""){
            jQuery(this).removeClass('selected');
          } else {
            jQuery(this).addClass('selected');
          }
        });
    });

  }
}
